<template>
    <div v-if="additionals">
        <div v-if="additionals.salaVacinacaoLogada && !!additionals.salaVacinacaoLogada.id">
            <rkm-data-table
                :fields="fields"
                :repository="repositories.aplicacaoCampanha"
                ref="RkmDataTable"
                sort-by="nome"
            >
                <template v-slot:cell(actions)="row">
                    <rkm-button
                        @click="handleEdit(row.item.id)"
                        authorize="store-imunizacao-aplicacao-campanha"
                        color="primary"
                        small
                        title="Visualizar"
                    >
                        <rkm-icon icon="search" />
                    </rkm-button>
                </template>
            </rkm-data-table>
        </div>

        <rkm-alert v-else color="warning">
            A unidade logada não é uma sala de vacinação, favor cadastrá-la para efetuar um registro de vacinação.
        </rkm-alert>
    </div>
</template>

<script>
// Enums.
import parametrizacaoDescricaoVacina from '@/enums/imunizacao/parametrizacaoDescricaoVacina'

// Mixins.
import { error, formats, permissao, repository } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        fields() {
            const fields = [
                { key: 'nome', label: 'Nome da campanha', name: 'imunizacaoCampanha.nome', searchable: true, sortable: true },
                { key: 'periodoDe', label: 'Periodo de', name: 'imunizacaoCampanha.periodoDe', searchable: true, sortable: true },
                { key: 'periodoAte', label: 'Periodo até', name: 'imunizacaoCampanha.periodoAte', searchable: true, sortable: true },
            ]

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    fields.push({ key: 'vacinaAbreviacao', label: 'Abreviação da vacina', name: 'cadastroVacina.abreviacao', searchable: true, sortable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    fields.push({ key: 'vacinaSigla', label: 'Sigla da vacina', name: 'cadastroVacina.sigla', searchable: true, sortable: true })
                    break;

                    case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    fields.push({ key: 'vacinaSiglaNome', label: 'Sigla e nome da vacina', name: 'cadastroVacina.siglaNome', searchable: true, sortable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    fields.push({ key: 'vacinaSiglaAbreviacao', label: 'Sigla e abreviação da vacina', name: 'cadastroVacina.siglaAbreviacao', searchable: true, sortable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    fields.push({ key: 'vacinaAbreviacaoNome', label: 'Abreviação e nome da vacina', name: 'cadastroVacina.abreviacaoNome', searchable: true, sortable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    fields.push({ key: 'vacinaSiglaAbreviacaoNome', label: 'Sigla, abreviação e nome da vacina', name: 'cadastroVacina.siglaAbreviacaoNome', searchable: true, sortable: true })
                    break;

                default:
                    fields.push({ key: 'vacinaNome', label: 'Nome da vacina', name: 'cadastroVacina.nome', searchable: true, sortable: true })
                    break;
            }

            if (this.verificarPermissao('create-imunizacao-aplicacao-campanha')) {
                fields.push({ class: 'col-min text-center', key: 'actions', label: 'Ações' })
            }

            return fields
        },
    },
    created() {
        this.repositories = {
            aplicacaoCampanha: this.getConectaSusRepository('imunizacao.aplicacaoCampanha')
        }
    },
    data: () => ({
        additionals: null,
        enums: { parametrizacaoDescricaoVacina },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.aplicacaoCampanha.index()
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleEdit(id) {
            this.$router.push({ name: 'imunizacao-aplicacao-campanha-create', params: { id: id } })
        },
    },
    mixins: [ error, formats, permissao, repository ],
    mounted() {
        this.load()
    },
}
</script>